module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/5_3ec3d3958bedf0e26f9280cdb4c9a792.jpg";